<template>
    <div class="feed-switch-mobile-wrapper device-element no-select" :class="{'active-mobile-switch': feedSwitch}">
        <div class="feed-switch-mobile feed-mobile-trending hover" @click="setSwitch(false);">
            <p>{{ switchOneText }}</p>
        </div>
        <div class="feed-switch-mobile feed-mobile-trending hover" @click="setSwitch(true);">
            <p>{{ switchTwoText }}</p>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
    import FeedSwitch from '../mixins/FeedSwitch.js'
    import Cookies from 'js-cookie'

    export default {
        mixins: [FeedSwitch],
        name: 'MobileFeedSwitch',

        methods: {
            setSwitch(bool) {
                this.$store.commit('setFeedSwitch', bool);

                let option = 'option1';

                //if turned on, set to option2
                if(bool === true) {
                    option = 'option2';
                }

                Cookies.set('feedstatus', option, {
                    expires: 365
                });
            }
        }
    }
</script>

<style lang="scss">

</style>